import Script from "next/script";
import { useCookieBotConsentReady } from "src/analytics/hooks/use-cookie-bot-consent-ready";
import { getClarityScriptCode } from "src/constants/script-templates";

interface IClarityScriptProps {
    clarityProjectId: string;
}

const global = globalThis as typeof globalThis & Window;

export const ClarityScript = ({ clarityProjectId }: IClarityScriptProps) => {
    const isConsentReady = useCookieBotConsentReady();
    const { consent } = global.Cookiebot ?? {};

    if (!isConsentReady || !consent) {
        return null;
    }

    return (
        <Script strategy="afterInteractive" id="clarityCode">
            {getClarityScriptCode(clarityProjectId)}
        </Script>
    );
};
